import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('phoneNumberField');

    return {
        PHONE_NUMBER_FIELD_LABEL: t('phoneNumberFieldLabel')
    };
};

export default useTranslation;
